var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0377 38.8738L85.927 41.8826L51.8703 77.3485L32.7612 57.7978L35.6244 54.7629L51.8445 71.3578L83.0377 38.8738Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0905 14.9392L20.748 14.3807C31.0309 5.64427 43.9822 0.863281 57.5566 0.863281C88.9887 0.863281 114.47 26.3695 114.47 57.8329C114.47 89.2962 88.9887 114.802 57.5566 114.802C26.1244 114.802 0.643555 89.2962 0.643555 57.8329C0.643555 47.7532 3.2652 37.9876 8.25879 29.3466L8.69057 28.5994L12.248 30.6593L11.8162 31.4065C7.18404 39.4221 4.75333 48.4775 4.75333 57.8329C4.75333 87.0242 28.3942 110.689 57.5566 110.689C86.7189 110.689 110.36 87.0242 110.36 57.8329C110.36 28.6415 86.719 4.97714 57.5566 4.97714C44.9588 4.97714 32.9492 9.41035 23.4074 17.5171L22.75 18.0757L20.0905 14.9392Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.fe5754df15598a011f77131a60556300.svg";
export { ForwardRef as ReactComponent };